<script>
import XEUtils from 'xe-utils'

export default {
  data() {
    return {
      data: {
        railWayLines: []
      },
      name: '选择铁路接轨线',
      show: false,
      rules: {
        railWayLines: [{ required: true, trigger: 'change', message: '选择铁路接轨线' }],
      },
      loading: false,
      railWayList: [],
      railWayLines: [],
      parentData: {}
    }
  },
  methods: {
    display(event) {
      this.railWayLines = event.railWayLines
      this.parentData = event.data
      this.data.railWayLines = []
      this.fetchRailWayList()
      this.show = true
    },
    fetchRailWayList() {
      this.railWayList = []
      let conditions = this.railWayLines.length > 0 ? [{ field: 'id', operator: 'notIn', value1: this.railWayLines.map(item => item.railway_line_id.id) }] : []
      const params = {
        conditions: conditions,
        pageNum: 1,
        pageSize: 6000,
        sorts: []
      }
      this.$axios.post('/paas/railway_line/list', params).then(res => {
        this.railWayList = res.data.data.list
      })
    },
    handleSave() {
      this.$refs.formRef.validate((vali) => {
        if (vali) {
          this.loading = true
          const params = {
            id: this.parentData.id,
            field_code: 'railway_lines',
            model_code: 'sys_shop',
            ids: this.data.railWayLines,
            name: this.parentData.name
          }
          this.$axios.post('/paas/eventEmit/m2mSelect', params).then(() => {
            this.$message.success({ showClose: true, message: '选择铁路接轨线成功' })
            this.loading = false
            this.show = false
            this.$emit('fetchRailWay')
          }).catch(() => {
            this.loading = false
            this.show = false
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<template>
  <el-dialog :visible.sync="show" :title="name" width="600px" append-to-body>
    <el-form ref="formRef" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
      <el-form-item prop="railWayLines" label="铁路接轨线">
        <el-select v-model="data.railWayLines" placeholder="请选择铁路接轨线" multiple filterable clearable
          style="width: 100%;">
          <el-option v-for="item in railWayList" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="handleSave" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>